// extracted by mini-css-extract-plugin
export var filterIncDec = "_3q-0";
export var leftBorder = "_3q-1";
export var rightBorder = "_3q-2";
export var stringInput = "_3q-3";